import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import { getBgColor } from 'src/utils/icons';

const QuantityReceived: FC<GridCellProps> = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;

  const errorMessages: string[] = useMemo(
    () => dataItem?.errors?.[field] || [],
    [dataItem?.errors, field]
  );

  const warningMessages: string[] = useMemo(
    () => dataItem?.warnings?.[field] || [],
    [dataItem?.warnings, field]
  );

  const InfosMessages: string[] = useMemo(
    () => dataItem?.informations?.[field] || [],
    [dataItem?.informations, field]
  );

  const value = dataItem[field]?.toString();
  const poQtyField = 'poQty';
  const poQtyValue = dataItem[poQtyField]?.toString();

  return (
    <GridCellBase {...props} className={getBgColor(errorMessages, warningMessages, InfosMessages)}>
      <p className="text-center">{Number(poQtyValue) === 0 ? 'N/A' : value}</p>
    </GridCellBase>
  );
};

export default QuantityReceived;
